import React, { useState, useEffect } from "react";
import "../Search/EmployeeForm"; // Ensure you create a CSS file for styles
import axios from "axios";

const EmployeeTwoWheeler = () => {
  const [formData, setFormData] = useState({
    vechical_no:"",
    date_of_purchase: "",
    particulars: "",
    used_by: "",
    original_cost: "",
    remark: "",
    transfer_to: "No", // Default to "No"
    transfer_date: "",
    reporting_manager: "",
  });

  const [pdfFile, setPdfFile] = useState(null); // Store the uploaded PDF file
  const [insurancePdfFile, setInsurancePdfFile] = useState(null);
  const [message, setMessage] = useState("");
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [isVisible, setIsVisible] = useState(true);

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleFileChange = (e, type) => {
    const file = e.target.files[0];
    if (type === "rc") {
      setPdfFile(file); // Store RC PDF file
    } else if (type === "insurance") {
      setInsurancePdfFile(file); // Store Insurance PDF file
    }
  };

  const handleClose = () => {
    setIsVisible(false);
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    const formDataToSend = new FormData();
    Object.keys(formData).forEach((key) => {
      formDataToSend.append(key, formData[key]);
    });

    if (pdfFile) {
      formDataToSend.append("rc_file", pdfFile); // Add the RC PDF file to the form data
    }

    if (insurancePdfFile) {
      formDataToSend.append("insurance_file", insurancePdfFile); // Add the Insurance PDF file to the form data
    }

    try {
      const response = await axios.post(
        "https://api.assetview.warrantyindia.com/api/sendvechical",
        formDataToSend,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      setMessage("Two-wheeler created successfully!");
      setShowConfirmation(true); // Show confirmation box
      setTimeout(()=>{
        setIsVisible(false);
      },1000)
      window.location.reload();
      console.log(response.data); // Ensure data is logged in console
    } catch (error) {
      console.error("Error submitting form", error);
      setMessage("An error occurred while creating the two-wheeler.");
      setShowConfirmation(true); // Show confirmation even on error
    }
  };

  useEffect(() => {
    const storedName = sessionStorage.getItem("name");
    if (storedName) {
      setFormData((prevData) => ({ ...prevData, used_by: storedName }));
    }
  }, []);

  return (
    <div className="modal-backdrop" style={{ display: isVisible ? "flex" : "none" }}>
      <div className="form-container" style={{ display: isVisible ? "block" : "none" }}>
        <button style={{ padding: "10px", color: "white", background: "red", border: "none" }} onClick={handleClose}>
          Close
        </button>
        <h2>Create New Two-Wheeler</h2>
        <form onSubmit={handleSubmit}>
          {/* Basic form fields */}

          <div className="form-group">
            <label>Vechical No</label>
            <input
              type="text"
              name="vechical_no"
              value={formData.vechical_no}
              onChange={handleInputChange}
              required
            />
          </div>


          <div className="form-group">
            <label>Date of Purchase</label>
            <input
              type="date"
              name="date_of_purchase"
              value={formData.date_of_purchase}
              onChange={handleInputChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Particulars</label>
            <input
              type="text"
              name="particulars"
              value={formData.particulars}
              onChange={handleInputChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Used By</label>
            <input
              type="text"
              name="used_by"
              value={formData.used_by}
              onChange={handleInputChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Original Cost</label>
            <input
              type="number"
              name="original_cost"
              value={formData.original_cost}
              onChange={handleInputChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Remark</label>
            <input
              type="text"
              name="remark"
              value={formData.remark}
              onChange={handleInputChange}
            />
          </div>

          <div className="form-group">
            <label>Transfer To</label>
            <select
              name="transfer_to"
              value={formData.transfer_to}
              onChange={handleInputChange}
              required
            >
              <option value="No">No</option>
              <option value="Yes">Yes</option>
            </select>
          </div>

          {formData.transfer_to === "Yes" && (
            <>
              <div className="form-group">
                <label>Transfer Date</label>
                <input
                  type="date"
                  name="transfer_date"
                  value={formData.transfer_date}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="form-group">
                <label>Reporting Manager</label>
                <input
                  type="text"
                  name="reporting_manager"
                  value={formData.reporting_manager}
                  onChange={handleInputChange}
                  required
                />
              </div>
            </>
          )}

          {/* RC PDF Upload */}
          <div className="form-group">
            <label>Upload RC PDF</label>
            <input
              type="file"
              accept="application/pdf"
              onChange={(e) => handleFileChange(e, "rc")}
            />
          </div>

          {/* Insurance PDF Upload */}
          <div className="form-group">
            <label>Upload Insurance PDF</label>
            <input
              type="file"
              accept="application/pdf"
              onChange={(e) => handleFileChange(e, "insurance")}
            />
          </div>

         

          <button type="submit" className="submit-btn">
            Submit
          </button>
        </form>

        {showConfirmation && (
          <div className="confirmation-modal">
            <p>{message}</p>
            <button
              onClick={() => setShowConfirmation(false)}
              className="close-confirmation-btn"
            >
              Close
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default EmployeeTwoWheeler;
